export const optionSortMethods = {
  STRING: "string",
  NUMBER: "number",
  DATE: "date",
  BOOLEAN: "boolean",
  SELECT_ITEM: (isAscending, a, b) =>
    isAscending
      ? a.label.localeCompare(b.label)
      : b.label.localeCompare(a.label),
  TIME_STRING: (isAscending, a, b) => {
    const aDate = new Date(
      `${new Date().toDateString()} ${new Date(a).toTimeString()}`,
    ).getTime() || 0;
    const bDate = new Date(
      `${new Date().toDateString()} ${new Date(b).toTimeString()}`,
    ).getTime() || 0;
    
      return isAscending ? aDate - bDate : bDate - aDate;
  },
};
